export default __webpack_public_path__ + "static/media/payment-method-napas-card.7369f772.svg";